// if you're using a bundler, first import:
import Headroom from "headroom.js";

const HeaderScroll = () => {
    // Find the header elemend
    var header = document.querySelector("header");
    // Mobile menu trigger button
    const headerButton = document.querySelector('.header__mobile');
    // body DOM element
    const body = document.querySelector('body');

    if (typeof headerButton != "undefined" && headerButton != null) {
        headerButton.addEventListener('click', () => {
            if (body.classList.contains('no-scroll')) {
                body.classList.remove('no-scroll');
            } else {
                body.classList.add('no-scroll');
            }
        });
    }

    // construct an instance of Headroom, passing the element
    var headroom  = new Headroom(header);
    // initialise
    headroom.init();
}

export default HeaderScroll;